/*
 *
 *  * Copyright(c) 2021 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { Component } from '@angular/core';
import { ModalConfig, ModalRef } from '@wfm/core';

@Component({
  selector: 'app-assignment-confirmation',
  templateUrl: './assignment-confirmation.component.html',
  styleUrls: ['./assignment-confirmation.component.scss']
})
export class AssignmentConfirmationComponent {
  rememberPref: boolean;

  constructor(public config: ModalConfig, public modalRef: ModalRef) {}

  onClose(value) {
    this.modalRef.close({
      result: value,
      rememberPref: this.rememberPref
    });
  }
}
